declare interface WindowWithMaps extends Window {
  google:
    | {
        maps: typeof google.maps | undefined
      }
    | undefined
}

export default function useGoogleMapsApi(): typeof google.maps {
  const windowWithMaps = window as WindowWithMaps
  if (windowWithMaps.google === undefined || windowWithMaps.google.maps === undefined) {
    throw new Error('Please use it inside @google-map-react')
  }

  return windowWithMaps.google.maps
}
